import { render, staticRenderFns } from "./DepositTable.html?vue&type=template&id=658f9fe2&scoped=true&"
import script from "./DepositTable.js?vue&type=script&lang=js&"
export * from "./DepositTable.js?vue&type=script&lang=js&"
import style0 from "./DepositTable.scss?vue&type=style&index=0&id=658f9fe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f9fe2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VPagination,VRow,VSkeletonLoader,VTab,VTabs})
